module.exports = __webpack_public_path__ + "static/media/number-five.b59c9e75.svg";